module.exports = __webpack_public_path__ + "static/media/icon-more.47821927.svg";